module.exports = __webpack_public_path__ + "8681f434273fd6a267b1a16a035c5f79.svg";


//////////////////
// WEBPACK FOOTER
// ./application/font/Roboto-Regular.svg
// module id = 343
// module chunks = 0